export default "__VITE_ASSET__DZHi0BNb__"